import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=6c5d62a3&scoped=true&lang=pug&"
import script from "./Profile.vue?vue&type=script&lang=js&"
export * from "./Profile.vue?vue&type=script&lang=js&"
import style0 from "./Profile.vue?vue&type=style&index=0&id=6c5d62a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5d62a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c5d62a3')) {
      api.createRecord('6c5d62a3', component.options)
    } else {
      api.reload('6c5d62a3', component.options)
    }
    module.hot.accept("./Profile.vue?vue&type=template&id=6c5d62a3&scoped=true&lang=pug&", function () {
      api.rerender('6c5d62a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fv_atril_video/Profile.vue"
export default component.exports